import { LegalDoc } from '../legal-doc.model';

/** Italian version — mirrors chroniq-privacy.de.ts section for section. */
export const CHRONIQ_PRIVACY_IT: LegalDoc = {
    title: 'Informativa sulla protezione dei dati Chroniq',
    meta: 'Stato: 3 novembre 2026 · Valida per l\'app Chroniq (iOS, web) e chroniq.ch',
    tocHeading: 'Indice',
    footer: 'Fa fede la versione tedesca. Le traduzioni servono alla comprensione.',
    sections: [
        {
            num: '01',
            title: 'Ripartizione dei ruoli: titolare e responsabile del trattamento',
            body: `
        <p>Chroniq è una soluzione software as a service multi-tenant messa a disposizione delle aziende
        (il «cliente» o «datore di lavoro») per la rilevazione delle ore e la gestione del personale.</p>
        <p>Nel trattamento dei dati dei collaboratori — rilevazione delle ore, pianificazione dei turni,
        assenze, chat, profilo — <strong>il datore di lavoro è il titolare del trattamento</strong> ai
        sensi della legge federale svizzera sulla protezione dei dati (LPD) e, ove applicabile, del
        regolamento generale sulla protezione dei dati (RGPD). La <strong>Gastro Management Group
        Oberbillig</strong> («la gerente», «noi») agisce in tal senso quale <strong>responsabile del
        trattamento</strong> secondo l'art. 9 LPD e l'art. 28 RGPD, sulla base di un contratto di
        responsabile del trattamento concluso con ogni cliente.</p>
        <p><strong>Siamo titolari in proprio</strong> per l'esercizio, la sicurezza e lo sviluppo della
        piattaforma, compresi i dati tecnici di diagnostica (n. 09), per la gestione del rapporto con la
        clientela e per il nostro sito web.</p>
        <p>La presente informativa illustra in modo completo i trattamenti svolti all'interno di Chroniq. I
        datori di lavoro possono utilizzarla anche come base per adempiere al proprio obbligo di
        informazione nei confronti dei collaboratori (art. 328b CO, art. 19 LPD, art. 13 seg. RGPD). I
        collaboratori rivolgono le domande su un trattamento concreto anzitutto al proprio datore di
        lavoro; restiamo a disposizione anche noi per le domande sulla piattaforma:</p>
        <p><strong>Gastro Management Oberbillig</strong><br>
        Ditta individuale, titolare: Erik Alexander Oberbillig<br>
        Gerente dell'app Chroniq<br>
        Kirchenrütti 14, 6463 Bürglen UR, Svizzera</p>
        <p>Protezione dei dati Chroniq: <a href="mailto:datenschutz@chroniq.ch">datenschutz&#64;chroniq.ch</a><br>
        Servizio centrale di protezione dei dati del gruppo: <a href="mailto:privacy@gastro-management.ch">privacy&#64;gastro-management.ch</a></p>
      `,
        },
        {
            num: '02',
            title: 'Dati di accesso',
            body: `
        <p>L'autenticazione avviene tramite <strong>Auth0</strong> su un tenant europeo
        (<code>*.eu.auth0.com</code>) con conservazione dei dati nell'UE. Il fornitore è Okta, Inc.
        Vengono trattati:</p>
        <ul>
          <li>indirizzo e-mail</li>
          <li>nome e cognome</li>
          <li>immagine del profilo (facoltativa, dal token di autenticazione)</li>
          <li>identificativo utente (Auth0 Subject Identifier)</li>
          <li>ruolo di accesso (<em>employee</em>, <em>chef</em>, <em>admin</em>)</li>
          <li>stato di onboarding</li>
        </ul>
        <p>Auth0 interviene quale responsabile del trattamento; con Okta, Inc. è in essere un contratto di
        responsabile del trattamento. Poiché la casa madre è soggetta al diritto statunitense e un accesso
        dagli Stati Uniti nell'ambito di supporto e manutenzione non può essere del tutto escluso, tale
        possibile elemento di estraneità è coperto dalle clausole contrattuali tipo dell'UE (n. 13).</p>
        <p><strong>Non memorizziamo password.</strong></p>
      `,
        },
        {
            num: '03',
            title: 'Dati di rilevazione delle ore',
            body: `
        <p>Tramite l'app vengono registrati:</p>
        <ul>
          <li>inizio, fine e data dei periodi di lavoro</li>
          <li>pause (inizio, fine, durata)</li>
          <li>stato del lavoro (in corso, in pausa, concluso)</li>
          <li>note facoltative sul periodo</li>
          <li>indicatori giornalieri e settimanali nonché il saldo delle ore supplementari</li>
        </ul>
        <p>Ne fanno parte le correzioni delle ore e le registrazioni successive, con motivazione e decisione del
        responsabile, nonché la chiusura mensile. Un <strong>registro delle modifiche</strong> documenta, per le
        modifiche ai dati del personale e delle ore, chi ha modificato che cosa e quando (identificativo e ruolo
        della persona agente, momento, record interessato, campi modificati). I campi sensibili come il numero
        AVS o l'IBAN non vi sono memorizzati in chiaro. Il registro serve alla tracciabilità nei confronti del
        datore di lavoro e alla sicurezza; non viene valutato per controllare il comportamento o le prestazioni
        (n. 19).</p>
        <p>Il trattamento serve ad adempiere all'obbligo di registrazione del datore di lavoro secondo
        l'art. 46 della legge sul lavoro e l'art. 73 dell'ordinanza 1 concernente la legge sul lavoro,
        nonché al corretto conteggio salariale.</p>
        <p><strong>Nessuna geolocalizzazione:</strong> Chroniq non raccoglie <strong>alcun</strong> dato di
        posizione del dispositivo al momento della timbratura e non elabora profili di spostamento.</p>
      `,
        },
        {
            num: '04',
            title: 'Rilevazione tramite terminali badge',
            body: `
        <p>Se un datore di lavoro impiega terminali badge RFID fisici, gli eventi di lettura (identificativo
        del badge, identificativo del dispositivo, momento) sono trattati tramite Microsoft Azure IoT Hub,
        attribuiti a un collaboratore e recepiti come timbratura di entrata o uscita; al terminale viene
        inviata una breve conferma. Al terminale si possono scansionare anche le pause (pausa, fine pausa).</p>
        <p>L'identificativo del badge è un semplice numero di tessera e non contiene caratteristiche
        biometriche.</p>
        <p>Dopo la lettura il terminale mostra brevemente il nome, l'esito e, se l'esercizio non lo ha
        disattivato, il totale della giornata (« Lavorato oggi » e « Pause »). Affinché il terminale funzioni
        anche senza connessione di rete, memorizza localmente in forma cifrata i nomi dei titolari dei badge
        e le letture non ancora inviate. Il gestore può accedere al dispositivo da remoto per la
        manutenzione. La conservazione dei dati di rilevazione del tempo è disciplinata dal n. 11.</p>
        <p>Al posto di una tessera fisica è possibile utilizzare anche un badge digitale in Apple Wallet
        (n. 08).</p>
        <p><em>Questa funzione è in fase pilota</em> ed è attivata solo presso singoli esercizi che
        impiegano espressamente il terminale gateway.</p>
      `,
        },
        {
            num: '05',
            title: 'Pianificazione dei turni e assenze',
            body: `
        <p>I responsabili creano i turni e decidono sulle richieste di assenza. Vengono trattati:</p>
        <ul>
          <li>orari e modelli di turno nonché esportazioni di calendario (iCal)</li>
          <li>tipo di assenza (<em>vacanze</em>, <em>malattia</em>, <em>infortunio</em>,
              <em>maternità/paternità</em>, <em>servizio militare</em>, <em>formazione</em>,
              <em>giorno di compensazione</em>, <em>altro</em>) quale mera categoria, senza campo per
              diagnosi o certificato, oltre a periodo, stato e conto vacanze</li>
          <li>richieste di scambio di turno tra collaboratori e la decisione del responsabile</li>
          <li>i campi di testo libero «nota» e «motivo del rifiuto»</li>
        </ul>
        <p><strong>Nota sulla minimizzazione dei dati:</strong> le categorie «malattia», «infortunio» e «maternità/paternità» non registrano
        tecnicamente alcuna diagnosi. I campi di testo libero sono però testo non verificato. Si invitano
        collaboratori e responsabili a non inserirvi indicazioni sulla salute né altri dati personali
        degni di particolare protezione (art. 5 lett. c LPD / art. 9 RGPD), salvo espressa necessità. Se
        tali dati vengono comunque inseriti, li trattiamo per conto del datore di lavoro con le medesime
        restrizioni di accesso previste per gli altri dati del personale.</p>
      `,
        },
        {
            num: '06',
            title: 'Dati e profilo dei collaboratori',
            body: `
        <p>Nel sistema sono gestiti i seguenti dati del personale:</p>
        <ul>
          <li>nome, indirizzo e-mail, numero di telefono</li>
          <li>numero di personale, funzione, reparto, data di entrata</li>
          <li>stato dell'invito (in attesa, accettato, revocato)</li>
          <li>immagine del profilo facoltativa in un contenitore di archiviazione privato, accessibile
              unicamente tramite indirizzi firmati a durata limitata</li>
        </ul>
        <p>Solo le persone con ruolo <em>chef</em> o <em>admin</em> possono inoltre trattare:</p>
        <ul>
          <li>numero AVS</li>
          <li>IBAN o coordinate bancarie</li>
          <li>data di nascita</li>
          <li>indirizzo di domicilio</li>
          <li>contatto di emergenza (nome, relazione, numero di telefono)</li>
        </ul>
        <p>Secondo l'art. 328b CO il datore di lavoro può trattare unicamente i dati che riguardano
        l'idoneità del lavoratore al rapporto di lavoro o che sono necessari all'esecuzione del contratto.
        Spetta al datore di lavoro compilare soltanto tali campi.</p>
      `,
        },
        {
            num: '07',
            title: 'Chat di squadra e comunicazioni',
            body: `
        <p>Se la funzione chat è attivata vengono trattati:</p>
        <ul>
          <li>contenuto del messaggio, mittente, momento nonché stato di modifica e cancellazione. I
              messaggi cancellati scompaiono dalla visualizzazione; il contenuto permane tecnicamente
              nell'archivio (cancellazione logica) e viene rimosso definitivamente con l'anonimizzazione
              dell'account o su istruzione del datore di lavoro.</li>
          <li>conferme di lettura per utente e per messaggio</li>
          <li>allegati (PDF, JPEG, PNG, al massimo 20 MB) in un contenitore di archiviazione privato,
              accessibili unicamente tramite indirizzi firmati validi un'ora</li>
          <li>comunicazioni per azienda: messaggi redatti da responsabili o amministratori e leggibili da
              tutti i collaboratori dell'azienda</li>
        </ul>
        <p>La chat serve alla comunicazione interna aziendale. Non ha luogo alcuna valutazione sistematica
        dei contenuti a fini di controllo del comportamento o delle prestazioni; essa è vietata al datore
        di lavoro ai sensi del n. 19.</p>
      `,
        },
        {
            num: '08',
            title: 'Notifiche e Apple Wallet',
            body: `
        <p>Sui dispositivi iOS le modifiche di turno, le richieste di scambio di turno, le correzioni delle ore e le decisioni
        sulle richieste di assenza attivano una notifica push tramite l'<strong>Apple Push Notification Service</strong>. A tal fine memorizziamo
        per ogni dispositivo un token push insieme a un identificativo del dispositivo; entrambi vengono
        cancellati al logout. I collaboratori possono disattivare le notifiche nelle impostazioni del
        profilo e nelle impostazioni di sistema del dispositivo. L'applicazione web non invia notifiche
        push; gli avvisi compaiono soltanto all'interno dell'applicazione aperta.</p>
        <p>Se il datore di lavoro ha attivato la notifica delle ore supplementari, i collaboratori ricevono
        a inizio mese un'e-mail con il proprio saldo di ore supplementari. L'invio avviene tramite Azure
        Communication Services (n. 12).</p>
        <p>Se la funzione Wallet è attivata, il backend genera un documento <em>.pkpass</em> firmato quale
        tessera del collaboratore. Esso è memorizzato localmente sul dispositivo; nel sistema permane
        soltanto lo stato di registrazione del dispositivo per gli aggiornamenti automatici.</p>
      `,
        },
        {
            num: '09',
            title: 'Dati tecnici di connessione e diagnostica',
            body: `
        <ul>
          <li>dati di connessione in tempo reale tramite <strong>Azure SignalR Service</strong> per gli
              aggiornamenti dal vivo</li>
          <li>metadati delle richieste (indirizzo IP, indirizzo richiamato, marca temporale, codice di
              stato) e registri degli errori, trattati da <strong>Azure Application Insights</strong> a
              scopo di esercizio, diagnostica e sicurezza</li>
        </ul>
        <p>Il trattamento avviene su infrastruttura Azure nell'UE. Per questi dati siamo titolari in
        proprio (n. 01).</p>
      `,
        },
        {
            num: '10',
            title: 'Finalità e basi giuridiche',
            body: `
        <ul>
          <li><strong>Esecuzione del contratto</strong> (art. 31 cpv. 2 lett. a LPD / art. 6 par. 1
              lett. b RGPD): fornitura della prestazione di rilevazione delle ore e gestione del personale
              al datore di lavoro ed esecuzione del contratto di lavoro.</li>
          <li><strong>Obbligo legale</strong> (art. 6 par. 1 lett. c RGPD): adempimento degli obblighi di
              registrazione e conservazione del diritto del lavoro secondo l'art. 46 LL, l'art. 73 OLL 1
              nonché degli obblighi contabili secondo il CO.</li>
          <li><strong>Interessi legittimi</strong> (art. 31 cpv. 1 LPD / art. 6 par. 1 lett. f RGPD):
              esercizio, sicurezza e prevenzione degli abusi della piattaforma, compresi i dati tecnici di
              diagnostica (n. 09).</li>
          <li><strong>Consenso</strong> (art. 6 cpv. 6 LPD / art. 6 par. 1 lett. a RGPD): funzioni
              puramente facoltative quali immagine del profilo, notifiche push e Apple Wallet, che i
              collaboratori attivano autonomamente. Nel rapporto di lavoro un consenso è valido solo se
              prestato liberamente; il suo rifiuto non comporta svantaggi e può essere revocato in ogni
              momento.</li>
        </ul>
      `,
        },
        {
            num: '11',
            title: 'Conservazione e cancellazione',
            body: `
        <p>I dati risiedono esclusivamente su infrastruttura <strong>Microsoft Azure</strong> nell'UE
        (principalmente Europa occidentale).</p>
        <ul>
          <li><strong>Dati di rilevazione e di turno:</strong> almeno 5 anni dalla scadenza della loro
              validità (art. 73 cpv. 2 OLL 1); successivamente cancellati o anonimizzati su istruzione del
              datore di lavoro o al termine del contratto. Una cancellazione automatica alla scadenza del
              termine non è attualmente attiva.</li>
          <li><strong>Registro delle modifiche (n. 03):</strong> contrassegnato per categoria di
              conservazione (dati di sessione 90 giorni, dati operativi 2 anni, dati giuridicamente rilevanti
              10 anni). Una cancellazione automatica non è attualmente attiva.</li>
          <li><strong>Documenti di rilevanza contabile:</strong> 10 anni (art. 958f CO).</li>
          <li><strong>Dati del personale:</strong> fino al termine del rapporto di lavoro e in seguito
              soltanto finché un obbligo legale o una pretesa azionabile lo richieda.</li>
          <li><strong>Messaggi di chat e comunicazioni:</strong> fino alla cancellazione da parte delle
              persone autorizzate o all'anonimizzazione dell'account corrispondente.</li>
          <li><strong>Dati tecnici di diagnostica (n. 09):</strong> secondo la conservazione standard di
              Azure Application Insights, di regola fino a 90 giorni.</li>
        </ul>
        <p>Il datore di lavoro può disporre termini più brevi per i dati di cui è titolare. Al termine del
        contratto cancelliamo o restituiamo i dati secondo le sue istruzioni.</p>
      `,
        },
        {
            num: '12',
            title: 'Destinatari e responsabili del trattamento',
            body: `
        <p>I dati sono comunicati soltanto a responsabili del trattamento contrattualmente vincolati al
        rispetto della protezione dei dati:</p>
        <ul>
          <li><strong>Okta, Inc. (Auth0)</strong> — autenticazione, tenant europeo con conservazione dei
              dati nell'UE; casa madre statunitense, coperta dalle clausole contrattuali tipo (n. 02, 13)</li>
          <li><strong>Microsoft Ireland Operations Limited (Azure)</strong> — infrastruttura cloud, banca
              dati e archiviazione, SignalR, Application Insights, invio di e-mail transazionali (Azure
              Communication Services, in particolare gli inviti ai collaboratori) e, se attivato, IoT Hub
              per i terminali badge; centri di calcolo nell'UE, principalmente Europa occidentale</li>
          <li><strong>Apple Inc.</strong> — recapito delle notifiche push e, se la funzione Wallet è
              attivata, messa a disposizione della tessera sul dispositivo</li>
          <li><strong>Cloudflare, Inc.</strong> — risoluzione dei nomi (DNS) nonché inoltro e protezione del traffico verso
              chroniq.ch; i dati di richiesta (in particolare l'indirizzo IP) transitano attraverso la rete globale di
              Cloudflare, anche al di fuori dell'UE; coperto da clausole contrattuali tipo (n. 13)</li>
        </ul>
        <p>Non hanno luogo comunicazioni ad altri terzi, utilizzi a scopo pubblicitario, vendite di dati
        personali né impieghi per l'addestramento di modelli di IA. Un elenco completo dei
        sub-responsabili è disponibile su richiesta; i nuovi sub-responsabili sono annunciati ai clienti in
        anticipo.</p>
      `,
        },
        {
            num: '13',
            title: 'Trattamento all\'estero',
            body: `
        <p>I dati sono conservati nell'UE. Singoli fornitori sono società statunitensi soggette al diritto
        degli Stati Uniti; un accesso dagli Stati Uniti nell'ambito di supporto e manutenzione non può
        essere del tutto escluso.</p>
        <p>Tali trasferimenti si fondano sulle <strong>clausole contrattuali tipo</strong> della
        Commissione europea (art. 46 par. 2 lett. c RGPD) in combinato disposto con l'art. 16 cpv. 2
        lett. d LPD, comprese le modifiche necessarie per la Svizzera, integrate dalla decisione di
        adeguatezza relativa all'<strong>EU–U.S. Data Privacy Framework</strong> e dal riconoscimento
        svizzero dello <strong>Swiss–U.S. Data Privacy Framework</strong>, purché il fornitore sia
        certificato. Manteniamo consapevolmente le clausole contrattuali tipo quale base autonoma, affinché
        il trasferimento resti coperto anche in caso di venir meno della decisione di adeguatezza.</p>
        <p>Una copia delle garanzie è disponibile su richiesta:
        <a href="mailto:datenschutz@chroniq.ch">datenschutz&#64;chroniq.ch</a></p>
      `,
        },
        {
            num: '14',
            title: 'Sicurezza dei dati',
            body: `
        <ul>
          <li>Tutte le trasmissioni sono cifrate tramite TLS/HTTPS; i dati a riposo sono cifrati.</li>
          <li>Gli accessi sono gestiti per ruoli; i campi degni di particolare protezione sono visibili
              solo ai ruoli autorizzati, con ulteriore protezione mediante filtro di riga specifico per
              tenant nella banca dati.</li>
          <li>Allegati e immagini del profilo risiedono in contenitori di archiviazione privati senza
              accesso anonimo e sono consegnati solo tramite indirizzi firmati a durata limitata.</li>
          <li>L'autenticazione avviene esclusivamente tramite Auth0 con OAuth 2.0 / OIDC.</li>
          <li>Nel portale web i token di accesso sono conservati nella memoria locale del browser fino alla
              disconnessione (tecnicamente necessario affinché la sessione sopravviva a un ricaricamento);
              sui dispositivi iOS nativi i valori critici per la sicurezza sono conservati nel portachiavi
              del sistema operativo.</li>
        </ul>
        <p>Le violazioni della sicurezza dei dati sono notificate all'IFPDT il più rapidamente possibile
        (art. 24 LPD). Poiché per i dati dei collaboratori siamo responsabili del trattamento, informiamo
        inoltre senza indugio il datore di lavoro interessato affinché possa adempiere ai propri obblighi
        di notifica — entro 72 ore secondo l'art. 33 RGPD.</p>
      `,
        },
        {
            num: '15',
            title: 'Cookie e memorie locali',
            body: `
        <p>Il sito web e l'app non impiegano cookie di marketing o di analisi di terzi. Sono utilizzate
        soltanto memorie locali tecnicamente necessarie:</p>
        <ul>
          <li>preferenza di visualizzazione (modalità chiara o scura)</li>
          <li>nel portale web i token di accesso (fino alla disconnessione) e, per gli amministratori,
              l'esercizio selezionato, affinché la sessione sopravviva a un ricaricamento</li>
          <li>memorizzazione temporanea delle rilevazioni in corso e una coda per le registrazioni
              effettuate senza connessione di rete, sincronizzata automaticamente al ripristino della
              connessione</li>
        </ul>
        <p>Per questi accessi tecnicamente necessari non è richiesto alcun consenso.</p>
      `,
        },
        {
            num: '16',
            title: 'I vostri diritti',
            body: `
        <p>In qualità di persona interessata avete diritto di accesso, rettifica, cancellazione,
        limitazione del trattamento, consegna o portabilità dei dati nonché di opposizione a un trattamento
        fondato su un interesse legittimo (art. 25 segg. LPD / art. 15 segg. RGPD). Potete revocare in ogni
        momento un consenso prestato, con effetto per il futuro.</p>
        <p>Poiché per i dati del personale agiamo quali responsabili del trattamento del datore di lavoro,
        inoltriamo le richieste relative a tali dati al datore di lavoro competente o le evadiamo su suo
        incarico. <strong>Vi preghiamo di rivolgere tali richieste anzitutto al vostro datore di
        lavoro.</strong></p>
        <p>Una richiesta di cancellazione è attuata tecnicamente mediante <strong>anonimizzazione</strong>
        dell'account del collaboratore: nome, recapiti, dati bancari e altri dati degni di particolare
        protezione sono rimossi in modo irreversibile dall'anagrafica del personale. Rimuoviamo
        separatamente, su istruzione del datore di lavoro, la foto del profilo, le registrazioni push e
        l'account di accesso presso il servizio di autenticazione. I dati di rilevazione, di turno e di audit permangono in forma
        anonimizzata per motivi legali di conservazione (art. 46 LL, art. 73 OLL 1, CO). I messaggi già
        inviati restano visibili con il nome valido al momento dell'invio, poiché tale nome è conservato
        storicamente nel messaggio.</p>
        <p>Contatto: <a href="mailto:datenschutz@chroniq.ch">datenschutz&#64;chroniq.ch</a></p>
        <p>Potete inoltre presentare reclamo all'<strong>Incaricato federale della protezione dei dati e
        della trasparenza (IFPDT)</strong>, Feldeggweg 1, 3003 Berna:
        <a href="https://www.edoeb.admin.ch" target="_blank" rel="noopener noreferrer">www.edoeb.admin.ch</a>.
        Se il trattamento rientra nel RGPD, avete altresì il diritto di rivolgervi all'autorità di
        controllo del vostro luogo di residenza o di lavoro (art. 77 RGPD).</p>
      `,
        },
        {
            num: '17',
            title: 'Clienti internazionali e diritto applicabile',
            body: `
        <p>Chroniq è impiegato in Svizzera e a livello internazionale. Applichiamo un regime graduato:</p>
        <ul>
          <li><strong>Svizzera:</strong> è determinante la LPD quale diritto del nostro Stato di sede.</li>
          <li><strong>UE/SEE:</strong> il RGPD si applica alle persone interessate nell'UE/SEE nella misura
              in cui forniamo prestazioni a imprese ivi stabilite oppure monitoriamo il comportamento di
              persone nell'UE/SEE (art. 3 par. 2 RGPD). La Svizzera beneficia di una decisione di
              adeguatezza dell'UE; i trasferimenti tra l'UE/SEE e la nostra infrastruttura svizzera non
              necessitano quindi di garanzie supplementari. Ove l'art. 27 RGPD lo richieda, designiamo un
              rappresentante nell'UE; i relativi recapiti saranno aggiunti qui non appena designato.</li>
          <li><strong>Regno Unito:</strong> si applica per analogia il UK GDPR.</li>
          <li><strong>Altri Paesi:</strong> rispettiamo le prescrizioni locali applicabili nella misura in
              cui incidano sulla nostra prestazione; addenda specifici per Paese sono disponibili su
              richiesta.</li>
        </ul>
      `,
        },
        {
            num: '18',
            title: 'Intelligenza artificiale',
            body: `
        <p>Chroniq non impiega <strong>alcun</strong> sistema di intelligenza artificiale ai sensi del
        regolamento (UE) 2024/1689 («regolamento sull'IA»). La pianificazione dei turni, il calcolo delle
        ore supplementari, il conto vacanze e la gestione delle richieste di assenza si fondano
        esclusivamente su una logica programmata basata su regole.</p>
        <p>Il regolamento sull'IA è generalmente applicabile dal 2 agosto 2026. Nell'ambito del personale è
        particolarmente severo: i sistemi di IA che assegnano compiti lavorativi sulla base del
        comportamento individuale o di caratteristiche personali, oppure che monitorano e valutano le
        prestazioni e il comportamento dei collaboratori, sono considerati <strong>sistemi ad alto
        rischio</strong> secondo l'allegato III n. 4. Il riconoscimento delle emozioni sul posto di lavoro
        è <strong>vietato</strong> dall'art. 5 par. 1 lett. f dal 2 febbraio 2025. Chroniq non contiene
        alcuna funzione di questo tipo.</p>
        <p>Qualora in futuro venisse introdotta una componente di IA — ad esempio nell'ambito di una
        funzione di analisi o di previsione —, procederemmo preventivamente alla sua classificazione
        secondo il regolamento sull'IA e aggiorneremmo la presente informativa prima della messa in
        esercizio. Per un sistema ad alto rischio il datore di lavoro dovrebbe inoltre adempiere, quale
        deployer, agli obblighi dell'art. 26, in particolare informare la rappresentanza dei lavoratori e i
        collaboratori interessati prima della messa in servizio (art. 26 par. 7).</p>
      `,
        },
        {
            num: '19',
            title: 'Nessun controllo del comportamento, nessuna decisione automatizzata',
            body: `
        <p>Chroniq non adotta decisioni basate unicamente su un trattamento automatizzato, compresa la
        profilazione, che producano effetti giuridici nei confronti dei collaboratori o incidano su di
        essi in modo analogamente significativo (art. 21 LPD / art. 22 RGPD). Le richieste di assenza,
        l'assegnazione dei turni, gli ammonimenti e la cessazione del rapporto di lavoro sono sempre
        decisi da una persona.</p>
        <p>Secondo l'art. 26 cpv. 1 dell'ordinanza 3 concernente la legge sul lavoro, i sistemi di
        sorveglianza o di controllo destinati a sorvegliare il comportamento dei lavoratori sul posto di
        lavoro <strong>non possono</strong> essere impiegati. Chroniq è destinato alla rilevazione del
        tempo di lavoro e all'organizzazione degli impieghi, non a una sorveglianza del comportamento. Il
        datore di lavoro si impegna contrattualmente a non utilizzare le funzioni di analisi per un
        controllo permanente del comportamento o delle prestazioni.</p>
      `,
        },
        {
            num: '20',
            title: 'Persone minorenni',
            body: `
        <p>Chroniq si rivolge ai collaboratori nell'ambito di un rapporto di lavoro. L'utilizzo da parte di
        collaboratori minorenni, ad esempio apprendisti, è di responsabilità del datore di lavoro; può
        essere necessario il consenso del rappresentante legale. Restano riservate le disposizioni
        particolari di protezione dei giovani lavoratori secondo gli art. 29 segg. LL e l'ordinanza sulla
        protezione dei giovani lavoratori, che il datore di lavoro deve osservare.</p>
      `,
        },
        {
            num: '21',
            title: 'Modifiche della presente informativa',
            body: `
        <p>Riesaminiamo regolarmente la presente informativa e la adeguiamo quando mutano la situazione
        giuridica o i nostri trattamenti. La versione in vigore è disponibile all'indirizzo
        <a href="https://www.gastro-management.ch/datenschutz?lang=it#chroniq">gastro-management.ch/datenschutz</a>.
        Informiamo gli utenti registrati delle modifiche sostanziali per e-mail. La data dell'ultima
        revisione figura nell'intestazione della pagina.</p>
      `,
        },
    ],
};
